import { createReducer, on } from '@ngrx/store';

import { SettingsReferenceEnum } from '../models';
import {
  IDocumentLayoutsDocument,
  IDocumentLayoutSummary,
} from '../models/documents/document-layout.interface';
import { documentLayoutActions } from './document-layout.actions';
import { settingsSetSelected } from './setting.actions';

export interface IDocumentLayoutState {
  error: string | null;
  layouts: IDocumentLayoutSummary[];
  loading: boolean;
  loadingLayouts: boolean;
  loadingPreview: boolean;
  loadingSettings: boolean;
  previewUrl: string | null;
  settingsByStore: { [storeId: string]: IDocumentLayoutsDocument };
}

export const initialDocumentLayoutState: IDocumentLayoutState = {
  error: null,
  layouts: [],
  loading: false,
  loadingLayouts: false,
  loadingPreview: false,
  loadingSettings: false,
  previewUrl: null,
  settingsByStore: {},
};

export const documentLayoutReducer = createReducer(
  initialDocumentLayoutState,
  on(settingsSetSelected.setSelectedReference, (state, { ref }) =>
    ref === SettingsReferenceEnum.featureAutoOrderDocumentLayouts
      ? { ...state, loadingLayouts: true, loadingSettings: true, error: null }
      : state,
  ),
  on(documentLayoutActions.loadLayouts, (state) => ({
    ...state,
    loadingLayouts: true,
    error: null,
  })),
  on(documentLayoutActions.loadSettings, (state) => ({
    ...state,
    loadingSettings: true,
    error: null,
  })),
  on(documentLayoutActions.saveSettings, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(documentLayoutActions.loadLayoutsSuccess, (state, { layouts }) => ({
    ...state,
    layouts,
    loadingLayouts: false,
  })),
  on(documentLayoutActions.loadLayoutsFailure, (state, { message }) => ({
    ...state,
    loadingLayouts: false,
    error: message,
  })),
  on(documentLayoutActions.loadSettingsSuccess, (state, { storeId, settings }) => ({
    ...state,
    settingsByStore: { ...state.settingsByStore, [storeId]: settings },
    loadingSettings: false,
  })),
  on(documentLayoutActions.loadSettingsFailure, (state, { message }) => ({
    ...state,
    loadingSettings: false,
    error: message,
  })),
  on(documentLayoutActions.saveSettingsSuccess, (state, { storeId, settings }) => ({
    ...state,
    settingsByStore: { ...state.settingsByStore, [storeId]: settings },
    loading: false,
  })),
  on(documentLayoutActions.preview, (state) => ({
    ...state,
    loadingPreview: true,
    error: null,
  })),
  on(documentLayoutActions.previewSuccess, (state, { url }) => ({
    ...state,
    previewUrl: url,
    loadingPreview: false,
  })),
  on(documentLayoutActions.clearPreview, (state) => ({
    ...state,
    previewUrl: null,
    loadingPreview: false,
  })),
  on(
    documentLayoutActions.saveSettingsFailure,
    documentLayoutActions.previewFailure,
    (state, { message }) => ({
      ...state,
      loading: false,
      loadingPreview: false,
      error: message,
    }),
  ),
);
